/**
 * @generated SignedSource<<9826d0c996232e68e061fff1b53fd594>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type JobLocationTypeEnum = "anywhere" | "full_address" | "job_timezone" | "specific_countries";
export type Position = "freelancer" | "permanent";
export type RateMode = "day" | "hour" | "month" | "week" | "year";
import { FragmentRefs } from "relay-runtime";
export type JobFormWrapper_Job$data = {
  readonly city: string | null | undefined;
  readonly clientRate: {
    readonly value: number;
  } | null | undefined;
  readonly country: string | null | undefined;
  readonly currency: {
    readonly code: string | null | undefined;
  } | null | undefined;
  readonly defaultDistance: number | null | undefined;
  readonly description: string | null | undefined;
  readonly descriptionExperience: string | null | undefined;
  readonly descriptionResponsibilities: string | null | undefined;
  readonly firm: {
    readonly description: string | null | undefined;
    readonly name: string | null | undefined;
    readonly slug: string | null | undefined;
    readonly website: string | null | undefined;
  } | null | undefined;
  readonly freelancerRate: {
    readonly value: number;
  } | null | undefined;
  readonly fullAddress: string | null | undefined;
  readonly industry: {
    readonly rawId: number | null | undefined;
  } | null | undefined;
  readonly jobCountries: ReadonlyArray<{
    readonly code: string | null | undefined;
    readonly name: string | null | undefined;
  }>;
  readonly jobSkills: ReadonlyArray<{
    readonly groupIndex: number | null | undefined;
    readonly id: string;
    readonly required: boolean | null | undefined;
    readonly requiredYears: number | null | undefined;
    readonly skill: {
      readonly id: string;
      readonly name: string;
    } | null | undefined;
  }>;
  readonly jobsSpecializations: ReadonlyArray<{
    readonly groupIndex: number | null | undefined;
    readonly specialization: {
      readonly name: string;
      readonly rawId: number | null | undefined;
    } | null | undefined;
  }>;
  readonly locationLatitude: number | null | undefined;
  readonly locationLongitude: number | null | undefined;
  readonly locationType: JobLocationTypeEnum | null | undefined;
  readonly minClientRate: {
    readonly value: number;
  } | null | undefined;
  readonly minFreelancerRate: {
    readonly value: number;
  } | null | undefined;
  readonly positionTypes: ReadonlyArray<Position>;
  readonly projectLengthInMonths: number | null | undefined;
  readonly rateMode: RateMode | null | undefined;
  readonly region: string | null | undefined;
  readonly requiredExperienceYears: number | null | undefined;
  readonly slug: string | null | undefined;
  readonly timezoneIdentifier: string | null | undefined;
  readonly timezoneRange: number | null | undefined;
  readonly timezoneUtcOffset: number | null | undefined;
  readonly title: string;
  readonly user: {
    readonly name: string | null | undefined;
    readonly rawId: number | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "JobFormWrapper_Job";
};
export type JobFormWrapper_Job$key = {
  readonly " $data"?: JobFormWrapper_Job$data;
  readonly " $fragmentSpreads": FragmentRefs<"JobFormWrapper_Job">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rawId",
  "storageKey": null
},
v4 = [
  (v3/*: any*/),
  (v1/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "groupIndex",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobFormWrapper_Job",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Firm",
      "kind": "LinkedField",
      "name": "firm",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "website",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "descriptionExperience",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "descriptionResponsibilities",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": (v4/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Industry",
      "kind": "LinkedField",
      "name": "industry",
      "plural": false,
      "selections": [
        (v3/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "JobsSpecialization",
      "kind": "LinkedField",
      "name": "jobsSpecializations",
      "plural": true,
      "selections": [
        (v5/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Specialization",
          "kind": "LinkedField",
          "name": "specialization",
          "plural": false,
          "selections": (v4/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "JobSkill",
      "kind": "LinkedField",
      "name": "jobSkills",
      "plural": true,
      "selections": [
        (v6/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "requiredYears",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "required",
          "storageKey": null
        },
        (v5/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Skill",
          "kind": "LinkedField",
          "name": "skill",
          "plural": false,
          "selections": [
            (v6/*: any*/),
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "positionTypes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Money",
      "kind": "LinkedField",
      "name": "freelancerRate",
      "plural": false,
      "selections": (v7/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Money",
      "kind": "LinkedField",
      "name": "minFreelancerRate",
      "plural": false,
      "selections": (v7/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Money",
      "kind": "LinkedField",
      "name": "clientRate",
      "plural": false,
      "selections": (v7/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Money",
      "kind": "LinkedField",
      "name": "minClientRate",
      "plural": false,
      "selections": (v7/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Currency",
      "kind": "LinkedField",
      "name": "currency",
      "plural": false,
      "selections": [
        (v8/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "requiredExperienceYears",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rateMode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectLengthInMonths",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "locationType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Country",
      "kind": "LinkedField",
      "name": "jobCountries",
      "plural": true,
      "selections": [
        (v8/*: any*/),
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timezoneIdentifier",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timezoneRange",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timezoneUtcOffset",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fullAddress",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "country",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "region",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "city",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "locationLatitude",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "locationLongitude",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "defaultDistance",
      "storageKey": null
    }
  ],
  "type": "Job",
  "abstractKey": null
};
})();

(node as any).hash = "fc137dcfcf09eb2a9f739af1831d5405";

export default node;
